import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'
import { Button, Modal, SelectAsync } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'


const AddAgency = () => {
  const { formatMessage } = useIntl()
  const [showModal, setShowModal] = useState(false)
  const [filterSupplier, setFilterSupplier] = useState(null)
  const history = useHistory()

  const loadSupplierOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/supplier?search[identifier]=${query}&search[status]=2,4`)
        .then(response => response.json())
        .then((suppliers) => {
          resolve(suppliers.map(({ uid, userid }) => ({
            value: uid,
            label: userid
          })))
        })
        .catch(reject)
    })
  }, 250)
  
  const onSubmit = () => {

    if (!filterSupplier) {
      toastr.error(formatMessage(messages.noSupplierSelected))
      return
    }

    fetch(`/rest/v2/agency`, {
      method: 'POST',
      body: JSON.stringify({
        supplierId: filterSupplier.value
      })
    }).then((response) => response.json())
      .then(({ data }) => {
        history.push(`/agencies/${data.uid}/members`)
      }).catch((error) => {
        toastr.error(error)
      })
  }

  return (
    <div>
      <Button
        icon={['fa', 'plus']}
        onClick={() => setShowModal(true)}
      >
        <FormattedMessage {...messages.addNewAgency} />
      </Button>

      <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          onOutsideClick={() => setShowModal(false)}
          onSubmit={() => onSubmit()}
          title={formatMessage(messages.addNewAgency)}
          dialogPanelClasses="overflow-visible" 
      >
        <div>
          <SelectAsync
            label={formatMessage(messages.selectLabel)}
            description={formatMessage(messages.selectDescription)}
            value={filterSupplier}
            onChange={(supplier) => setFilterSupplier(supplier)}
            cacheOptions
            loadOptions={(query) => loadSupplierOptions(query)}
            openMenuOnFocus
            placeholder={formatMessage(messages.selectPlaceholder)}
            isClearable
          />
          <div className='mt-2 float-right'>
            <Button
              onClick={() => onSubmit()}
            >
              <FormattedMessage {...messages.submitAgency} /> 
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default AddAgency
